import countries from "@/assets/json/countries.json";

/**
 * Formats any date string or Date object into a YYYY-MM-DD input string.
 */
export const formatDate = (inputDate: string | Date): string => {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
};

/**
 * Maps countries JSON to unique React-Select compatible currency options sorted alphabetically.
 */
export const getUniqueCurrencies = () => {
  const value = countries.map((item) => {
    return { label: item.currency, value: item.currency };
  });

  const seenValues = new Set();
  const uniqueArray = value
    .filter((item) => {
      if (seenValues.has(item.value)) {
        return false;
      }
      seenValues.add(item.value);
      return true;
    })
    .sort((a, b) => {
      return a.value.localeCompare(b.value);
    });

  return uniqueArray;
};
